import { createFileRoute } from '@tanstack/react-router'

import { RequestsContainer } from '../../components/dashboard/components/RequestsContainer'

export const Route = createFileRoute('/app/requests')({
  component: RouteComponent,
})

function RouteComponent() {
  return <RequestsContainer />
}
